import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", form);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-line bg-surface p-10" data-testid="admin-login-form">
        <p className="label-caps text-mist">Area riservata</p>
        <h1 className="mt-3 font-display text-3xl text-ivory">Accesso admin</h1>
        <div className="mt-8 flex flex-col gap-5">
          <div>
            <label className="label-caps mb-2 block text-ivory/60" htmlFor="admin-email">Email</label>
            <input id="admin-email" type="email" required data-testid="admin-email-input" className="input-dark"
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="label-caps mb-2 block text-ivory/60" htmlFor="admin-password">Password</label>
            <input id="admin-password" type="password" required data-testid="admin-password-input" className="input-dark"
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full disabled:opacity-60">
            {loading ? <Loader2 size={14} className="animate-spin" /> : "Accedi"}
          </button>
        </div>
        <Link to="/" className="label-caps mt-8 block text-center text-mute transition-colors duration-300 hover:text-ivory" data-testid="admin-back-home">
          Torna al sito
        </Link>
      </form>
    </div>
  );
}
